<template>
<div>
    <label>{{$t('message.Reason')}}</label>
    <b-form-textarea
        id="textarea"
        v-model="text"
        placeholder="Enter something..."
        rows="3"
        max-rows="6"
    ></b-form-textarea>
    <div class="button">
      <b-button variant="primary" @click="sendSubmit">{{$t('message.Send')}}</b-button>
    </div>
</div>
</template>

<script>
import {callUserToTest} from "../../../../../../../api/school-vacany-applications";

export default {
  name: "DenyApplication",
  props: {
    testStatus: {
      type: Object,
      required: true,
    },
    app: {
      required: true,
      default: null,
    },
  },
  data(){
    return{
      text: '',
      school_id: null,
      school_name: '',
      vacancy_id: null,
    }
  },
  methods:{
    async sendSubmit() {
      if(this.text) {
        let form = {...this.testStatus};
        form.school_id = this.app.school_id;
        form.school_name = this.app.school.organizationshortname;
        form.vacancy_id = this.app.id;
        form.description = this.text;
        callUserToTest(form).then(res => {
          this.$emit('closeDenyForm',{id: this.testStatus.application_id, data: res.data.data})
        })
      }
    }
  }
}
</script>

<style scoped>
.button{
  margin-top: 20px;
  margin-left: 200px;
}
</style>
